import { useEffect, useState } from "react";
import { siteName } from "@/mocks/works";

const navItems = [
  { id: "#home", label: "首页" },
  { id: "#categories", label: "作品分类" },
  { id: "#ranking", label: "人气排行" },
  { id: "#recommend", label: "作品推荐" },
  { id: "#roundups", label: "专题盘点" },
  { id: "#reviews", label: "同好口碑" },
  { id: "#faq", label: "常见问题" },
  { id: "#about", label: "关于我们" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/90 shadow-sm backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-20 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#home" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-heart-3-fill text-lg" aria-hidden="true"></i>
          </span>
          <span
            className={`font-heading text-lg md:text-xl font-bold tracking-tight ${
              scrolled ? "text-foreground-900" : "text-foreground-900"
            }`}
          >
            {siteName}
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={item.id}
              className="rounded-full px-3.5 py-2 text-sm font-medium text-foreground-700 hover:bg-primary-100/70 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#ranking"
            className="hidden md:inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors"
          >
            看人气排行
            <i className="ri-fire-line text-base" aria-hidden="true"></i>
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-200/70 lg:hidden cursor-pointer"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
          >
            <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-line"}`} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200/70 bg-background-50 px-4 py-3 md:px-6">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={item.id}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-primary-100/70 hover:text-primary-700 transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}